/*
 * @Author: cc
 * @Date: 2019-11-25 12:52:25
 * @LastEditTime : 2019-12-20 16:25:36
 * @LastEditors  : cc
 * @FilePath: \xjmediacloud\app\editingCenter\website\preview\previewRouter.js
 * @Description:
 */

'use strict';
angular.module('websitePreviewRouterModule', ['websitePreviewModule']).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider.state('websitePreviewAll', {
            url: '/websitepreview?wzchannelid&wzchnldocid&wzsiteid&wzmetadataid&wzplatform&wztypeid&isawaitrevise&fromsearch',
            views: {
                '': {
                    templateUrl: './editingCenter/website/preview/websitePreview.html',
                    controller: 'websitePreviewCtrl',
                },
            },
        });
    },
]);
